module.exports = __webpack_public_path__ + "static/media/YB5M16_3.12567998.jpg";